import { render, staticRenderFns } from "./Page8.vue?vue&type=template&id=a0a1ea42&scoped=true&"
import script from "./Page8.vue?vue&type=script&lang=js&"
export * from "./Page8.vue?vue&type=script&lang=js&"
import style0 from "./Page8.vue?vue&type=style&index=0&id=a0a1ea42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a1ea42",
  null
  
)

export default component.exports